import styled from 'styled-components';

export const DayStyle = styled.div(props => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    border: "1px solid #E8E9EC",
}));